
import { create } from "zustand";

interface PolicyNumberStore {
  policyNumber: any;
  setPolicyNumber: (policyNumber: string | null) => void;
}

export const usePolicyNumberStore = create<PolicyNumberStore>((set)=>({
      policyNumber: null,
      setPolicyNumber: (policyNumber) => set({ policyNumber }),
    })
  );
